import { useState } from 'react';
import { feedbackApi } from '@/api/endpoints';
import { Alert, Button, Card, Notice } from '@/components/ui';
import uiStyles from '@/components/ui.module.css';

const MESSAGE_MAX = 2000;

/**
 * Freies Feedback an die Admins (Migration 018). Wird per Mail verschickt UND
 * in der DB gespeichert — Mailversand auf dem Shared-Host ist nicht garantiert,
 * die Nachricht geht also nicht verloren, auch wenn die Mail nicht ankommt.
 */
export function FeedbackPage() {
  const [message, setMessage] = useState('');
  const [anonymous, setAnonymous] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  const valid = message.trim() !== '' && message.length <= MESSAGE_MAX;

  async function send() {
    setBusy(true);
    setError(null);
    try {
      await feedbackApi.send({ message: message.trim(), anonymous });
      setSent(true);
      setMessage('');
      setAnonymous(false);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Senden fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card>
      <h2>Feedback</h2>
      <p className="muted">
        Anregungen, Lob, Kritik oder ein Bug — schreib uns, was dir auffällt. Die Nachricht geht
        direkt an die Admins.
      </p>

      {sent && <Notice>Danke! Deine Nachricht ist angekommen.</Notice>}

      <label className={uiStyles.field} htmlFor="feedback-message">
        <span className={uiStyles.label}>
          Nachricht ({message.length}/{MESSAGE_MAX})
        </span>
        <textarea
          id="feedback-message"
          className={uiStyles.input}
          rows={6}
          maxLength={MESSAGE_MAX}
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
            setSent(false);
          }}
          placeholder="Deine Nachricht an die Admins…"
        />
      </label>

      <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
        <input
          type="checkbox"
          checked={anonymous}
          onChange={(e) => setAnonymous(e.target.checked)}
        />
        Anonym senden (dein Name wird den Admins nicht angezeigt)
      </label>

      {error && <Alert>{error}</Alert>}

      <Button disabled={busy || !valid} onClick={() => void send()}>
        {busy ? 'Wird gesendet…' : 'Feedback senden'}
      </Button>
    </Card>
  );
}
